module.exports = __webpack_public_path__ + "static/media/rejected.a6aeef64.wav";